export default function TachesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('taches');
}

TachesConfiguration.$inject = ['$translatePartialLoaderProvider'];
